import { QUANTITE } from '../../types/typeDef';
import { Niveau } from '../../types/note/niveau.def';

const softSkillsCalcul = {
  implication: (qtevente: QUANTITE): Niveau => {
    let niveau: Niveau = 0;
    if (qtevente >= 1) niveau = 1;
    if (qtevente >= 2) niveau = 2;
    if (qtevente >= 5) niveau = 3;
    if (qtevente >= 10) niveau = 4;
    return niveau;
  },
  adaptConsigne: (qterebond: QUANTITE): Niveau => {
    let niveau: Niveau = 0;
    if (qterebond >= 1) niveau = 1;
    if (qterebond >= 2) niveau = 2;
    if (qterebond >= 3) niveau = 3;
    if (qterebond >= 5) niveau = 4;
    return niveau;
  },
  depassementSoi: (qteca: QUANTITE): Niveau => {
    let niveau: Niveau = 0;
    if (qteca >= 25) niveau = 1;
    if (qteca >= 50) niveau = 2;
    if (qteca >= 250) niveau = 3;
    if (qteca >= 500) niveau = 4;
    return niveau;
  },
  curiosite: (qtequiz: QUANTITE): Niveau => {
    let niveau: Niveau = 0;
    if (qtequiz >= 1) niveau = 1;
    if (qtequiz >= 2) niveau = 2;
    if (qtequiz >= 3) niveau = 3;
    if (qtequiz >= 5) niveau = 4;
    return niveau;
  },
  btoc: (qtevente: QUANTITE, qtepro: QUANTITE): Niveau => {
    const qteBtoC = qtevente - qtepro;
    let niveau: Niveau = 0;
    if (qteBtoC >= 1) niveau = 1;
    if (qteBtoC >= 5) niveau = 2;
    if (qteBtoC >= 10) niveau = 3;
    if (qteBtoC >= 15) niveau = 4;
    return niveau;
  },
  btob: (qtepro: QUANTITE): Niveau => {
    let niveau: Niveau = 0;
    if (qtepro >= 1) niveau = 1;
    if (qtepro >= 2) niveau = 2;
    if (qtepro >= 3) niveau = 3;
    if (qtepro >= 5) niveau = 4;
    return niveau;
  }
};

export default softSkillsCalcul;
